import {Injectable} from "@angular/core";
import {ResponsiveService} from "../orchestration/responsive.service";

@Injectable()
export class GeolocateService {

    private static readonly MAX_AGE: number = 5 * 60 * 1000;

    public position: Position;

    constructor(private responsiveService: ResponsiveService) {
        console.log("--- GeolocateService");
    }

    /**
     * Get current location, returning a cached version if the elapsed time since getting their location is less than a threshold.
     * @returns {Promise<Position>}
     */
    async getCurrentLocation(timeout: number = 10000): Promise<Position> {
        if (this.responsiveService.isIpad && this.responsiveService.isIOSChrome) {
            throw "Cannot perform location lookup in chrome on iPad";
        }

        console.log("Looking up current location");
        return new Promise<Position>((resolve, reject) => {
            const timer: any = setTimeout(() => {
                reject("Geolocation failed to complete");
            }, timeout + 500);
            navigator.geolocation.getCurrentPosition(
                (position: Position) => {
                    clearTimeout(timer);
                    this.position = position;
                    console.log("Current location from browser: " + this.position.coords.latitude + ", " + this.position.coords.longitude);
                    resolve(this.position);
                },
                (error: PositionError) => {
                    clearTimeout(timer);
                    console.log(error.toString());
                    if (this.position) {
                        resolve(this.position);
                    } else {
                        console.log("Unable to determine current location from browser");
                        reject(error.toString());
                    }
                },
                {
                    timeout: timeout,
                    enableHighAccuracy: true,
                    maximumAge: GeolocateService.MAX_AGE
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/store/geolocate.ts